import axios from 'axios';
import FastAPIInstance from '../../../../../services/risksystem3-public-api';
import { KIDOverviewData } from '../../../../../types/pages/raidr.types';
import { KID_PDF_GENERATOR_BASE_URL, PDF_GENERATOR_BASE_URL } from '../../../../../utilities/apiConstants';
import { AxiosInstance } from '../../../../../utilities/requestClient';

export const getKIDsGeneratorOverviewData = async (clientId: string) => {
  return (
    await FastAPIInstance.get<KIDOverviewData[]>(
      `v1/raidr/kid_overview_data/${clientId}`,
    )
  ).data;
};

export const getKIDContentData = async (
  clientId: string,
  fundId: string,
  isin: string,
  documentLanguage: string,
  version?: string | null,
) => {
  const url = [
    'v1/raidr/get_kid_data',
    clientId,
    fundId,
    isin,
    documentLanguage,
    version, // will be skipped if undefined/null
  ]
    .filter(Boolean)
    .join('/');

  const response = await FastAPIInstance.get(url);
  return response.data;
};

export const getKIDsReviewData = async (
  clientId: string,
  fundId: string,
  isin: string,
  targetVersion: string,
  comparisonVersion: string,
  documentLanguage: string,
) => {
  return (
    await FastAPIInstance.get(
      `v1/raidr/get_kid_review_changes/${clientId}/${fundId}/${isin}/${targetVersion}/${comparisonVersion}/${documentLanguage}`,
    )
  ).data;
};

export const generateNewKID = async (formData: FormData) => {
  return await AxiosInstance.post(
    `${PDF_GENERATOR_BASE_URL}/generate_new_kiid`,
    formData,
    {
      headers: {
        accept: 'application/pdf',
      },
      responseType: 'blob',
    },
  );
};

export const generateNewReviewKID = async (formData: FormData) => {
  return await AxiosInstance.post(
    `${PDF_GENERATOR_BASE_URL}/generate_new_review_kiid`,
    formData,
    {
      headers: {
        accept: 'application/pdf',
      },
      responseType: 'blob',
    },
  );
};

export const getKIDsFigureData = async (
  clientId: string,
  fundId: string,
  shareClass: string,
) => {
  return (
    await FastAPIInstance.get(
      `v1/raidr/get_kid_figures_data_by_share_class/${clientId}/${fundId}/${shareClass}`,
    )
  ).data;
};



export const saveKidDocument = async (payload: {
  client_id: string;
  fund_id: string;
  share_class_id: string;
  document_language: string;
  updated_kid_data_models: any[];
  updated_kid_templates?: any[];
}) => {
  return (await FastAPIInstance.post(`/v1/kid/data/update`, payload)).data;
};

export const revertKidDocument = async (
  clientId: string,
  fundId: string,
  shareClassId: string,
  documentLanguage: string,
  version: string,
) => {
  const params = new URLSearchParams({
    document_language: documentLanguage,
    version: version,
  });

  return (
    await FastAPIInstance.delete(
      `/v1/kid/data/revert_kid_document/${clientId}/${fundId}/${shareClassId}?${params.toString()}`,
    )
  ).data;
};



